export default "__VITE_ASSET__CDojBmlk__"